import Blizfieldhome1 from '../../Media/homeimages/Blizfield 10.webp'
import Blizfieldhome2 from '../../Media/homeimages/Blizfield 10.webp'





const Blizfieldhomeimages =[
Blizfieldhome1,Blizfieldhome2
]

export default Blizfieldhomeimages;